import AdminLayout from "../../../components/admin/layout/AdminLayout";
import ManagerSingleView from "../../../components/admin/manager/ManagerSingleView";
import { useLocation } from "react-router-dom";

function ManagerSingleViewPage() {
  const location = useLocation();
  const id = location.state || {};
  return (
    <AdminLayout>
      <ManagerSingleView id={id} />
    </AdminLayout>
  );
}

export default ManagerSingleViewPage;
